export default "__VITE_ASSET__cd1bb8f3__"